import { ShieldCheck } from 'lucide-react';
import React from 'react';

import { SingleModuleAuditPage } from '@/features/imports/SingleModuleAuditPage';

export const AuditInsuranceImportsPage = (): React.JSX.Element => (
  <SingleModuleAuditPage
    config={{
      moduleKey: 'insurance',
      titlePlural: 'insurance',
      routePrefix: 'insurance',
      listPath: '/insurance',
      ListIcon: ShieldCheck,
    }}
  />
);
